<template>
	<div class="flex h-full w-full">
		<card :to="props.to" class="w-full">
			<div class="flex flex-column items-center justify-center w-full h-full">
				<cdn-background-image :size="{width: 512, ratio: 32/15}" src="/finisherpoints/widget/2023-01.jpeg" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.3)" cover
									  class="absolute w-full h-full top-0"/>
				<div class="z-1 p-4">
					<div class="font-heading font-bold text-center text-white my-4 text-3xl sm:text-4xl lg:text-5xl">
						<count-up-number :start="isUserInitiallyLoaded ? $auth.user.finisherpoints : 0" :end="$auth.user?.finisherpoints ?? 0"/>
					</div>
					<div class="text-secondary text-2xs sm:text-sm text-center font-bold leading-spaced">{{ $t('label.finisherpoints') }}</div>
				</div>
			</div>
		</card>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	to?: String,
}>();

const {$auth} = useNuxtApp();

const isUserInitiallyLoaded = !!$auth.user;
</script>